export enum WeekRangeType {
    CURRENT_WEEK = 'CURRENT_WEEK',
    LAST_WEEK = 'LAST_WEEK',
    TODAY = 'TODAY',
    FOUR_WEEKS = 'FOUR_WEEKS'
}
